import { Stack, Typography } from "@mui/material";

import { ISOStringToLocalReadableTimestamp } from "utils";

export interface SupplierShipmentDetailTitleShipment {
  info: Pick<SupplierShipmentInfo, "id" | "type" | "custom_name"> & {
    booked_at: string | null;
  };
  supplier: { user: { first_name: string; last_name: string } };
  supplier_company: { name: string };
}

interface Props {
  shipment: SupplierShipmentDetailTitleShipment | undefined;
}

export function SupplierShipmentDetailTitle(props: Props) {
  const { shipment } = props;

  if (!shipment) {
    return <Typography variant="h4">Shipment -</Typography>;
  }

  let shipmentNoun = "Shipment";
  if (shipment?.info?.type === "MULTI_SHIPMENT_PROJECT") {
    shipmentNoun = "Project";
  }

  // booked_at is only set once the shipment is booked. The public page renders
  // this title for pre-booking statuses too, so guard the label to avoid
  // formatting a null timestamp into "Invalid DateTime".
  const timestampLabel = shipment.info.booked_at ? (
    <Typography variant="body2" color="text.secondary">
      {`Booked by ${shipment.supplier.user.first_name} ${shipment.supplier.user.last_name} on ${ISOStringToLocalReadableTimestamp(shipment.info.booked_at)} from ${shipment.supplier_company.name}`}
    </Typography>
  ) : null;

  if (shipment.info.custom_name != null && shipment.info.custom_name !== "") {
    return (
      <Stack direction="column" spacing={0}>
        <Typography
          variant="h4"
          sx={{
            whiteSpace: "normal",
            overflow: "hidden",
            textOverflow: "ellipsis",
            wordBreak: "break-word",
            maxWidth: "100%",
          }}
        >
          {shipment.info.custom_name}
        </Typography>
        <Typography variant="h5" color="text.secondary">
          {`${shipmentNoun} ${shipment.info.id}`}
        </Typography>
        {timestampLabel}
      </Stack>
    );
  }

  return (
    <Stack direction="column" spacing={0}>
      <Typography variant="h4">
        {shipmentNoun} {shipment.info.id}
      </Typography>
      {timestampLabel}
    </Stack>
  );
}
